import { render, staticRenderFns } from "./Payslip.vue?vue&type=template&id=07f6a2da&scoped=true"
import script from "./Payslip.vue?vue&type=script&lang=js"
export * from "./Payslip.vue?vue&type=script&lang=js"
import style0 from "./Payslip.vue?vue&type=style&index=0&id=07f6a2da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f6a2da",
  null
  
)

export default component.exports